module.exports = __webpack_public_path__ + "static/media/jolandakooi.5deeec09.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/jolandakooi.webp
// module id = 498
// module chunks = 0